export const localStorageMiddleware =
  (reducerKey: string) => (store: any) => (next: any) => (action: any) => {
    const ret = next(action)
    if (action.type?.startsWith(`${reducerKey}/`)) {
      const state = store.getState()[reducerKey]
      const stateToBeStored = {} as Record<string, any>
      for (const key in state) {
        // skip keys that start with _
        if (key.startsWith('_')) {
          continue
        }
        stateToBeStored[key] = state[key]
      }
      localStorage.setItem(reducerKey, JSON.stringify(stateToBeStored))
    }
    return ret
  }

export const loadStateFromLocalStorage = <T>(reducerKey: string, initialState?: T): T => {
  const storedState = localStorage.getItem(reducerKey)
  const loadedState = storedState ? JSON.parse(storedState) : {}

  // If initialState is provided, merge it with loaded state to ensure all keys exist
  return initialState ? { ...initialState, ...loadedState } : loadedState
}

export const initialConversationUUID = () => {
  const { pathname } = new URL(window.location.href)
  return pathname.split('/').pop()!
}
